// @flow

import ActionTypes from '.'

export const setSmallScreen = () => ({
  type: ActionTypes.SMALL_SCREEN
})

export const setMediumScreen = () => ({
  type: ActionTypes.MEDIUM_SCREEN
})

export const setLargeScreen = () => ({
  type: ActionTypes.LARGE_SCREEN
})